import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Col, Form, Popconfirm, Row } from "antd";
import { useState } from "react";
import { ContentBlockerField, EUserRole, TRANSLATABLE_CONTENT_BLOCKER_TEMPLATE_ATTRIBUTES_LIST } from "@devowl-wp/api-real-cookie-banner";
import { useTranslation } from "../../../../../../others/i18n.js";
import { spacing } from "../../../../../../styles/spacing.js";
import { getFieldNameTranslated } from "../../../../../../util/template/translation.js";
import { CodeMirrorWrapper } from "../../../../../third-party/code-mirror-wrapper.js";
import { FormFieldVisibilityWrapper } from "../../formFieldVisibilityWrapper.js";
function FormFieldContentBlockerTemplateExampleEmbedCodeList() {
    const { t } = useTranslation();
    const [dirtyMap, setDirtyMap] = useState({});
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
        fieldNames: ContentBlockerField.ExampleEmbedCodes,
        permissionCheck: {
            whenRole: EUserRole.Translator,
            roleWhiteList: TRANSLATABLE_CONTENT_BLOCKER_TEMPLATE_ATTRIBUTES_LIST
        },
        children: /*#__PURE__*/ _jsx(Form.Item, {
            label: getFieldNameTranslated(ContentBlockerField.ExampleEmbedCodes, t),
            children: /*#__PURE__*/ _jsx(Form.List, {
                name: ContentBlockerField.ExampleEmbedCodes,
                children: (fields, { add, remove })=>/*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Form.Item, {
                                children: /*#__PURE__*/ _jsx(Button, {
                                    onClick: ()=>add(),
                                    style: {
                                        maxWidth: "10rem"
                                    },
                                    icon: /*#__PURE__*/ _jsx(PlusOutlined, {}),
                                    children: t("Add")
                                })
                            }),
                            fields.map((field, index)=>/*#__PURE__*/ _jsxs(Row, {
                                    style: {
                                        marginBottom: spacing.layout.content.margin
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Col, {
                                            style: {
                                                width: "95%"
                                            },
                                            children: /*#__PURE__*/ _jsx(Form.Item, {
                                                ...field,
                                                validateTrigger: [
                                                    "onChange",
                                                    "onBlur"
                                                ],
                                                noStyle: true,
                                                children: /*#__PURE__*/ _jsx(CodeMirrorWrapper, {
                                                    options: {
                                                        mode: "javascript",
                                                        lineNumbers: true
                                                    },
                                                    onChange: ()=>setDirtyMap({
                                                            ...dirtyMap,
                                                            [index]: true
                                                        })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Col, {
                                            style: {
                                                minWidth: "32px",
                                                maxWidth: "10rem",
                                                textAlign: "center"
                                            },
                                            children: /*#__PURE__*/ _jsx(Popconfirm, {
                                                disabled: dirtyMap[index] !== true,
                                                placement: "right",
                                                title: t("Are you sure to delete this entry?"),
                                                onConfirm: ()=>remove(index),
                                                okText: t("Yes"),
                                                cancelText: t("No"),
                                                children: /*#__PURE__*/ _jsx(Button, {
                                                    icon: /*#__PURE__*/ _jsx(DeleteOutlined, {}),
                                                    onClick: ()=>{
                                                        if (dirtyMap[index] !== true) {
                                                            remove(index);
                                                        }
                                                    },
                                                    onDoubleClick: ()=>remove(index)
                                                })
                                            })
                                        })
                                    ]
                                }, `exampleEmbedCode-item-${index}`))
                        ]
                    })
            })
        })
    });
}
export { FormFieldContentBlockerTemplateExampleEmbedCodeList };
